import $dom from 'cash-dom';

let isMobileNavigation = false;

const init = () => {
  storeAnnouncementBarHeight();
  markCobrandedSite();

  manageEventListeners();
  $dom(window).on('resize', manageEventListeners);
};

const manageEventListeners = () => {
  const mobileMenuMaxBreakpoint = 1024;
  const shouldBeMobileNavigation = window.innerWidth < mobileMenuMaxBreakpoint;

  if (!isMobileNavigation && shouldBeMobileNavigation) {
    isMobileNavigation = true;
    $dom('[data-depth-control]').on('click', onDepthControlClick);
  }

  if (isMobileNavigation && !shouldBeMobileNavigation) {
    isMobileNavigation = false;
    $dom('[data-depth-control]').off('click', onDepthControlClick);
  }
};

function onDepthControlClick(event) {
  event.preventDefault();

  const $target = $dom(event.target);
  const $depthEl = $dom('[data-depth-control-current]');
  const currentDepth = Number.parseInt($depthEl.data('depthControlCurrent'));
  const increment = $target.data('depthControl');

  if ($target.hasClass('main-navigation-mobile-trigger')) {
    return toggleMenu(currentDepth);
  }

  if (currentDepth === -1) {
    return showMenu();
  }

  if (currentDepth === 0 && increment === -1) {
    return hideMenu();
  }

  return incrementDepth(event, increment);
}

function toggleMenu(currentDepth) {
  return currentDepth === -1 ? showMenu() : hideMenu();
}

function showMenu() {
  const $depthEl = $dom('[data-depth-control-current]');
  $dom('body').addClass('mobile-menu-open');

  $depthEl.data('depthControlCurrent', 0);
  setTimeout(() => {
    $dom(window).on('click', clickOutsideListener);
  });
}

function hideMenu() {
  const $depthEl = $dom('[data-depth-control-current]');
  $dom('body').removeClass('mobile-menu-open');

  $depthEl.data('depthControlCurrent', -1);
  hideMenuItems();
  $dom(window).off('click', clickOutsideListener);
}

function incrementDepth(event, increment) {
  if (typeof increment !== 'number') return;

  const $depthEl = $dom('[data-depth-control-current]');
  const currentDepth = Number.parseInt($depthEl.data('depthControlCurrent'));

  $depthEl.data('depthControlCurrent', currentDepth + increment);

  increment > 0 ? revealMenuItem(event) : hideMenuItems(event);
}

function revealMenuItem(event) {
  const $parentElement = $dom(event.target.parentElement);
  $parentElement.addClass('is-visible');

  const $submenuItem = $parentElement.find('ul');
  $submenuItem.addClass('is-visible');
}

function hideMenuItems() {
  $dom('.navigation-child.is-visible').removeClass('is-visible');
  $dom('.navigation-item.is-visible').removeClass('is-visible');
}

function clickOutsideListener(event) {
  const clickedOutside = !$dom(event.target).closest('.main-navigation').length;

  if (clickedOutside) hideMenu();
}

const storeAnnouncementBarHeight = () => {
  // will be used to set the height of mobile menu in CSS
  const root = document.documentElement;
  const container = document.querySelector('.announcement-container');
  const height = (container && container.clientHeight + 'px') || '0px';

  root.style.setProperty('--announcement-container-height', height);
};

const markCobrandedSite = () => {
  const isCobranded = !!document.querySelector('.main-header.is-cobranded');

  if (isCobranded) {
    const pageContainer = document.querySelector('.page-container');
    pageContainer.classList.add('is-cobranded');
  }
};

export default init;
